// material-ui
import { styled } from '@mui/material/styles';
import { Box, Button, MenuItem, Select, Typography } from '@mui/material';

// assets
import { IconWallet } from '@tabler/icons';
import { shouldForwardProp } from '@mui/system';
import { getChainToken, supportedChains, useWallet } from 'hooks/useWallet';
import walletHelpers from 'helpers/walletHelpers';
import useContract from 'hooks/useContract';
import chains from 'data/chains';
import { withTheme } from '@mui/styles';

const ChainSwitcher = () => {
  // const contract = useContract();
  const wallet = useWallet();

  return (
    <>
      <Box sx={{ display: { md: 'block' } }}>
        <StyledSelect
          sx={{ width: '200px', backgroundColor: 'background.default' }}
          value={wallet.chainId}
          label="Destination Chain"
          onChange={(event) => wallet.switchNetwork(event.target.value)}
        >
          {supportedChains.map((chainId) => (
            <MenuItem key={chainId} value={chainId}>
              {chains[chainId].displayName}
            </MenuItem>
          ))}
        </StyledSelect>
      </Box>
    </>
  );
};

const StyledSelect = withTheme(styled(Select)`
  .MuiSelect-select.MuiSelect-outlined.MuiOutlinedInput-input.MuiInputBase-input.css-d3muob-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
    background-color: ${(props) => props.theme.palette.background.default};
  }
`);

export default ChainSwitcher;
